import React from "react";
import styled from "styled-components";
import {
  ArrowDownRight01Icon,
  ArrowUpRight01Icon,
  MinusSignIcon,
} from "@hugeicons/core-free-icons";
import HugeIcon from "src/components/HugeIcon";
import { tone as tones, Tone } from "src/theme/ui";

/**
 * The direction a figure moved.
 *
 * One implementation, used by both the cards and the table, so a gain looks
 * the same wherever it is read.
 *
 * A rising or falling arrow rather than a triangle. The triangle it replaces
 * was drawn out of borders, which meant it could not take a stroke weight or
 * a size from anywhere and sat as a filled wedge against stroked glyphs
 * everywhere else on the page. An arrow also says which way rather than only
 * that something moved, and a flat figure gets a neutral minus so a zero
 * change never reads as a drop.
 */

const Mark = styled.span<{ $tone: Tone }>`
  display: inline-flex;
  flex: none;
  align-items: center;
  color: ${({ $tone }) => tones[$tone].fg};
`;

const glyph = {
  up: ArrowUpRight01Icon,
  down: ArrowDownRight01Icon,
  flat: MinusSignIcon,
} as const;

const TrendMark: React.FC<{ $tone: Tone; size?: number }> = ({
  $tone,
  size = 13,
}) => (
  <Mark $tone={$tone}>
    <HugeIcon icon={glyph[$tone]} size={size} strokeWidth={2.5} />
  </Mark>
);

export default TrendMark;
